import { combineReducers, configureStore } from "@reduxjs/toolkit";
import SocketSlice from "./SocketSlice";
import AuthSlice from "./AuthSlice";
import DataSlice from "./DataSlice";
import ChatSlice from "./ChatSlice";
import TicketSlice from "./TicketSlice";
import AnnouncementReducer from "./AnnouncementSlice";
import NotificationsSlice from "./NotificationsSlice";
import MeetinTicketReducer from "./MeetingTicketSlice";
import SidebarDataLoadingSlice from "./SidebarDataLoadingSlice";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { noop } from "@tanstack/react-table";

const persistConfig = {
  key: "root",
  storage,
  version: 1,
};

const persistedDatarReducer = persistReducer(persistConfig, DataSlice);

// Combine reducers, mixing persisted and non-persisted slices
const rootReducer = combineReducers({
  data: persistedDatarReducer, // Persisted reducer
  socket: SocketSlice, // Non-persisted reducers
  auth: AuthSlice,
  ticket: TicketSlice,
  conversation: ChatSlice,
  announcement: AnnouncementReducer,
  notifications: NotificationsSlice,
  meetingTicket: MeetinTicketReducer,
  sidebarDataLoading: SidebarDataLoadingSlice,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),

  devTools: true,
});

export const persistor = persistStore(store);
